// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IVc7gKWrO0YvvhK2JqH0{justify-content:space-between;width:100%;padding:8px 4px 0 0;display:flex}.g24LL0zUa87xxKajGsR5{position:relative}.g24LL0zUa87xxKajGsR5:before{z-index:var(--zIndex-BASE_5);background-color:var(--white-50);content:"";position:absolute;top:0;bottom:0;left:0;right:0}.i40ajamSTyorRJcosJPA{align-items:center;display:flex}.oqQlfuAJxOQcXtDkkpbV{margin-right:2px}.oqQlfuAJxOQcXtDkkpbV:last-of-type{margin-right:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `IVc7gKWrO0YvvhK2JqH0`,
	"disabled": `g24LL0zUa87xxKajGsR5`,
	"box": `i40ajamSTyorRJcosJPA`,
	"boxItem": `oqQlfuAJxOQcXtDkkpbV`
};
export default ___CSS_LOADER_EXPORT___;
